define([
	"dojo/_base/declare",
	"csi/heading/RefContainer",
	"./_ValueAttributeMixin"
], function(declare,RefContainer,ValueAttributeMixin) {

	return declare([RefContainer,ValueAttributeMixin], {

	});
});
